
// Temporary production config
const productionConfig = require('./config.production');
module.exports = productionConfig;
